"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _CustomIconOrImage = _interopRequireDefault(require("../../../shared/CustomIconOrImage"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CollapsibleHeaderContentWrapper = _styledComponents.default.div`
  display: flex;
  gap: 8px;
`;
const CollapsibleBodyContentWrapper = _styledComponents.default.div`
  display: flex;
  gap: 10px;
  padding: ${props => `8px ${props.padding} 0px ${props.padding} `};
`;
const Wrapper = _styledComponents.default.div`
  & .injected-svg {
    stroke: #0d0d0d;
  }
`;
const CollapsibleCharacteristic = _ref => {
  let {
    icon,
    text,
    description,
    planIndex
  } = _ref;
  const imageSource = {
    sm: icon,
    md: icon,
    lg: icon
  };
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const collapsibleFeatureDescriptionSpacing = (0, _useLocalTheme.default)(`recommendation.collapsibleFeatureDescriptionSpacing`, {});
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-test-id": `accordion-${planIndex}`
  }, description ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerHeader, null, /*#__PURE__*/_react.default.createElement(CollapsibleHeaderContentWrapper, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    src: imageSource,
    testId: `feature-icon-${planIndex}`
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `feature-name-${planIndex}`
    }
  }, text))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerBody, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `feature-desc-${planIndex}`
    },
    size: 1
  }, /*#__PURE__*/_react.default.createElement(CollapsibleBodyContentWrapper, {
    padding: `${collapsibleFeatureDescriptionSpacing[breakpoints.current] + 8}px`
  }, description)))) : /*#__PURE__*/_react.default.createElement(CollapsibleHeaderContentWrapper, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    testId: `feature-icon-${planIndex}`,
    src: imageSource
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `feature-name-${planIndex}`
    }
  }, text)));
};
var _default = CollapsibleCharacteristic;
exports.default = _default;